import request from '../utils/request.js'

export function home() {
    return request({
        url:"/home/route",
        method: 'get'        
    })
}
export function index() {
    return request({
        url:"/home/v1/index",
        method: 'get'        
    })
}
export function sendCode(data) {
    return request({
        url:`/sms/v1/sendCode?phone=${data.phone}`,
        method: 'get'        
    })
}

export function login(data) {
    return request({
        url: "/user/v1/login",
        method: 'post',
        data,
        headers:{
            "content-type":"application/json"
        }
    })
}
export function productInfo(data) {
    return request({
        url: `/product/v1/product-info?id=${data.id}`,
        method: 'get'
    })
}
export function handheld (data) {
    return request({
        url:"authen/upload",
        method:"post",
        needForm: true,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}
export function ocr(data) {
    return request({
        url:"/auth/v1/ocr-separate",
        method:"post",
        needForm: true,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}

export function key_submit(data) {
    return request({
        url:"/auth/v1/kyc-info/aadhaar-pan",
        method: "post",
        data
    })
}
export function manual_submit(data) {
    return request({
        url:"/auth/v2/kyc-info/aadhaar-pan",
        method: "post",
        data
    })
}
export function manual_phone_submit(data) {
    return request({
        url:"/auth/v1/szy/aadhaar-verify",
        method: "post",
        data
    })
}

export function base_info() {
    return request({
        url:"/auth/v1/auth-page-info?type=baseInfo",
        method: "get",
    })    
}
export function work_info() {
    return request({
        url:"/auth/v2/auth-page-info?type=workInfo",
        method: "get",
    })    
}
// 地区
export function mapDistrict(stateId) {
    return request({
        url:`/map-state/v1/district/${stateId}`,
        method: "get"        
    })    
}
// 地区
export function mapState() {
    return request({
        url:"/map-state/v1/list",
        method: "get"        
    })    
}

// 基本信息提交
export function base_submit(data) {
    return request({
        url: '/auth/v1/base-info',
        method:'post',
        data
    })
}
// 工作信息提交
export function work_submit(data) {
    return request({
        url: '/auth/v1/work-info',
        method:'post',
        data
    })
}
//
export function contact_relation(){
    return request({
        url: '/auth/v1/auth-page-info?type=contactInfo',
        method:'get'
    })
}

export function contact_relation2(token){
    return request({
        url: '/auth/pageInfo?type=contactInfo',
        method:'get',
        token
    })
}
// 提交联系人信息
export function submit_contact(data) {
    return request({
        url:'/auth/v1/contacts',
        method: 'post',
        data
    })
}
export function submit_contact2(data, token) {
    return request({
        url:'/authen/coontacts',
        method: 'post',
        data,
        token
    })
}
// 查询认证情况
export function getAuthInfo() {
    return request({
        url:'/auth/v1/find-user-auth',
        method: 'get',
    })
}
export function getKycinfo() {
    return request({
        url:'/auth/v1/find-user-kyc-type',
        method: 'get',
    })
}
export function getAuthItemState() {
    return request({
        url:'/auth/v1/find-user-auth-item-state',
        method: 'get',
    })
}
export function getUserAuthState() {
    return request({
        url:'/auth/v2/find-user-auth-state',
        method: 'get',
    })
}
// 活体获取地址
export function getActiveUrl() {
    return request({
        url:"authen/h5/face-token",
        method:'get'
    })
}
// 活体获取结果
export function getActiveResult() {
    return request({
        url:'authen/h5/face-result',
        method:'get'        
    })
}
// 试算
export function calculate(data) {
    return request({
        url:`/order/v1/calculate?amount=${data.amount}&period=${data.period}&productId=${data.productId}`,
        method:'get',        
    })
}
// 查询银行卡
export function getBank() {
    return request({
        url: '/bank/v1/find-user-bank-card',
        method: 'get',
        // data
    })
}
// ifsccode 银行
export function getIfscBank() {
    return request({
        url:"/bank-info/v1/get-bank-info",
        method:"get"
    })
}
// ifsccode 州
export function getIfscState(data) {
    return request({
        url:`/bank-info/v1/get-state-list?pId=${data.pId}`,
        method:"get",
    })
}
// ifsccode 城市
export function getIfscCity(data) {
    return request({
        url:`/bank-info/v1/get-city-list?stateId=${data.pId}`,
        method:"get",
    })
}
// ifsccode branch
export function getIfscBranch(data) {
    return request({
        url:`/bank-info/v1/get-branch-list?cityId=${data.pId}`,
        method:"get",
    })
}
// 绑卡
export function bindCard(data) {
    return request({
        url:'/bank/v1/bind-card',
        method: 'post',
        data
    })
}
// 申请
export function apply(data) {
    return request({
        url:'/order/v1/apply',
        method: 'post',
        data
    })
}
// 订单详情
export function productDetailInfo(data) {
    return request({
        url:'/api/order/apply',
        method: 'post',
        data
    })
}
// 订单列表
export function getOrders() {
    return request({
        url:'/order/v4/unfinish-order-list',
        method: 'get'
    })
}
export function getFinishOrders() {
    return request({
        url:'/order/v5/finished-order-list',
        method: 'get'
    })
}
// 申请订单详情
export function orderDetail (data) {
    return request({
        url:`/order/v1/detail?orderId=${data.orderId}`,
        method: "get",        
    })
}
// 还款
export function repay (data) {
    return request({
        url:"/pay-order/v1/repay",
        method: "post",
        data
    })
}
// 确认用款
export function confirm(data) {
    return request({
        url:"/order/v1/loan",
        method: "post",
        data
    })
}
// 问答
export function qa() {
    return request({
        url:"/client/v1/faq",
        method: "get"        
    })
}
// 关于我们
export function aboutus() {
    return request({
        url:"/client/v1/about-us",
        method: "get"        
    })
}
// 提交gps
export function gps(data) {
    return request({
        url:"/device/h5/upload/base_info",        
        method:'post',
        data,
        needForm:true,
        headers:{
            "Content-Type": "application/json"
        }
    })
}
// 活体
export function newFace(data) {
    return request({
        url:"/authen/h5/face",        
        method:'post',
        data,
        needForm:true,
        headers:{
            "Content-Type": "application/json"
        }
    })
}
export function faceConfig () {
    return request({
        url: '/auth/v1/living-check-config',
        method:"get"
    })
}
export function liveBody (data) {
    return request({
        url: '/auth/v3/living-check',
        method:'post',
        data,
        needForm:true,
        headers:{
            "Content-Type": "multipart/form-data"
        }
    })
}
// 获取
export function getCountry() {
    return request({
        url:"/system/get-country"
    })
}
export function bury(data) {
    return request({
        url:"/burying-point/v2/burying-point",
        method:'post',
        data:[data],
        needForm:true,
        headers:{
            "Content-Type": "application/json"
        }
    })
}
export function buryv3(data) {
    return request({
        url:"/burying-point/v3/burying-point",
        method:'post',
        data:[data],
        needForm:true,
        headers:{
            "Content-Type": "application/json"
        }
    })
}
export function systemConfig() {
    return request({
        url:"/system/v1/system-config"
    })
}

// 三方认证提交
export function adaPan(data) {
    return request({
        url:"/auth/v1/kyc-info/aadhaar-pan",
        method:"post",
        data
    })
}
export function ada3url(data) {
    return request({
        url:"/auth/aadhaar/get-h5-url",
        method:"post",
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}

export function identityConfig() {
    return request({
        url:'/auth/kyc-auth-config?type=4'
    })
}
export function identityConfig6() {
    return request({
        url:'/auth/kyc-auth-config?type=6'
    })
}

export function livingHold() {
    return request({
        url:'/auth/v1/kyc-info/living-hold',
        method:"post",
    })
}

export function submitAppInfo(data,headers) {
    return request({
        url:'/user/v1/user-login',
        method:"post",
        "customeHeaders":headers,
        data,
        "noToken":true     
    })
}
export function submitAppInfo2(data,headers) {
    return request({
        url:'/tripartite/v1/user-login',
        method:"post",
        "customeHeaders":headers,
        data,
        "noToken":true     
    })
}

export function zySendCode(data) {
    return request({
        url:'/auth/v3/aadhaar/send-otp',
        method:"post",
        data
    })
}
export function verifyZyCode(data) {
    return request({
        // url:'/auth/aadhaar/verify',
        url:"/auth/v1/aadhaar/verify",
        method:"post",
        data
    })
}

// 前筛
export function prechech(data) {
    return request({
        url:`/order/v1/precheck?productId=${data.productId}`,
        method:"get"        
    })
}
export function uploadDeviceInfo(data) {
    return request({
        url:`/device/v1/upload/device_info`,
        method: "post",
        data
    })
}
export function isNeedUplod() {
    return request({
        url:`/device/v1/needUpload`,
        method: "post",        
    })
}
export function tryExtension(orderId) {
    return request({
        url:`/order-repay-extension/v1/extension-calc/${orderId}`,
        method: "get",        
    })
}
export function giveUpExtension(data) {
    return request({
        url: "/order-repay-extension/v1/giveup-extension",
        method: "post",
        data
    })
}
export function applyExtension(data) {
    return request({
        url: "/order-repay-extension/v1/apply-extension",
        method: "post",
        data
    })
}
export function feedback(data) {
    return request({
        url: "/opinion-record/v1/save",
        method: "post",
        needForm:true,
        headers:{
            "Content-Type": "multipart/form-data"
        },
        data
    })
}
export function feedbackList() {
    return request({
        url: "/opinion-record/v1/list",
        method: "post"        
    })
}
export function beforeReapply(data) {
    return request({
        url: "/order/v1/order-auto-apply",
        method: "post",
        data
    })
    
}
export function autoList() {
    return request({
        url: "/order/v1/get-auto-apply-list ",
        method: "get",
    })
}

export function autoDetail(orderId) {
    return request({
        url: `/order/v1/get-auto-apply?orderId=${orderId}`,
        method: "get",
    })
}
export function cancelAuto(data) {
    return request({
        url: "/order/v1/cancel-auto-apply",
        method: "post",
        data
    })
}

export function bury2(data) {
    return request({
        url:"burying-point/burying-point/save-buried-point",
        method:'post',
        data:data,
        needForm:true,
        headers:{
            "Content-Type": "application/json"
        }
    })
}

export function subscribe(data) {
    return request({
        url:"webpush/subscribe",
        method:'post',
        data:data,
        headers:{
            "Content-Type": "application/json"
        }
    })
}

export function buryConfig() {
    return request({
        url:"burying-point/burying-point/get-buried-config",
        method:'get'        
    })
}

export function feedbackConfig() {
    return request({
        url:"opinion-record/v1/get-opinion-config",
        method:'get'        
    })
}
export function getConfig() {
    return request({
        url: "/client/v1/config",
        method: "get",        
    })
}

export function sendValidateSms(data) {
    return request({
        url: "/sms/v2/aadhaar/send-sms-otp",
        method: "post",        
        data
    })    
}
export function submitValidateSms(data) {
    return request({
        url: "/auth/v1/aadhaar/sms/otp/verify",
        method: "post",        
        data
    })    
}

export function getAadhaar() {
    return request({
        url: "/auth/v1/sms/otp/get-aadhaar",
    })    
    
}

export function voiceCode (data) {
    return request({
        url:`/sms/v1/sendVoiceCode?phone=${data.phone}&type=${data.type}`,
        method: 'get'        
    })
    
}

export function getLastPhoneByAadhaar(data) {
    return request({
        url:`/auth/v1/kyc-aadhaar-verify`,
        method: 'post',
        data
    })
}
export function aadhaarMobileVerify(data) {
    return request({
        url:`/auth/v1/kyc-aadhaar-mobile-verify`,
        method: 'post',
        data
    })
}
export function smsOtpVerify (data) {
    return request({
        url:`/auth/v2/aadhaar/sms/otp/verify`,
        method: 'post',
        data
    })
    
}